import clsx from 'clsx';
import React, { FC } from 'react';

import AudioVisualizer from '0_canvas/AudioVisualizer/AudioVisualizer';
import ClientCanvas from '0_canvas/ClientCanvas/ClientCanvas';
import { useAudioVisualizerStore } from 'state/audioVisualizerStore';
import { publicAssets } from 'utils/gcs';

import S from './AudioVisualizerCanvas.module.scss';

export interface AudioVisualizerCanvasProps {}

const AudioVisualizerCanvas: FC<AudioVisualizerCanvasProps> = () => {
  const position = useAudioVisualizerStore(s => s.position);
  const visible = useAudioVisualizerStore(s => s.visible);

  return (
    <div
      className={clsx({
        [S.CanvasWrapper]: true,
        [S.Visible]: visible,
        [S.Center]: position === 'CENTER',
        [S.Bottom]: position === 'BOTTOM',
      })}
    >
      <div
        className={S.Blur}
        style={{
          backgroundImage: `url(${publicAssets(
            '/audioVisualizer/texture.png'
          )})`,
        }}
      ></div>
      <div className={S.Inner}>
        <ClientCanvas
          className={S.Canvas}
          camera={{ near: 0.001, far: 5000 }}
          isOverLayout
        >
          <AudioVisualizer />
        </ClientCanvas>
      </div>
    </div>
  );
};
export default AudioVisualizerCanvas;
